import { useEffect, useState } from 'react';
import { useDeviceDetect } from '../../util';
export const useHorizontalScroll = (ref, slideSpeed = 1) => {
  const [isMoving, setIsMoving] = useState(false);
  const {
    isMobile
  } = useDeviceDetect();
  useEffect(() => {
    if (ref !== null && ref !== void 0 && ref.current && !isMobile) {
      const slider = ref.current;
      let isDown = false;
      let startX;
      let scrollLeft;
      const onMouseDown = e => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      const onMouseMove = e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * slideSpeed;
        slider.scrollLeft = scrollLeft - walk;
        if (!isMoving && (walk > 5 || walk < -5)) setIsMoving(true);
      };
      const onMouseLeave = () => isDown = false;
      const onMouseUp = () => {
        isDown = false;
        setTimeout(() => setIsMoving(false), 0);
      };
      slider.addEventListener('mousedown', onMouseDown);
      slider.addEventListener('mouseleave', onMouseLeave);
      slider.addEventListener('mouseup', onMouseUp);
      slider.addEventListener('mousemove', onMouseMove);
    }
  }, []);
  return isMoving;
};